module.exports = __webpack_public_path__ + "static/media/right.db8b47fb.png";